// extracted by mini-css-extract-plugin
module.exports = {"altHero":"xf","altProd":"yf","subheading":"zf","subtext":"Af","extrainfo":"Bf","copy":"Cf","cta":"Df","disabled":"Ef"};